// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"87c6fa94","494":"964b9681","510":"406d90c6","911":"a5e8254e","939":"7f63763b"}[chunkId] + ".chunk.js";
};